// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__2lAvX","btn_icon":"Button_btn_icon__5feIW"};